import { render, staticRenderFns } from "./bannerTop.vue?vue&type=template&id=aa423138&scoped=true&"
import script from "./bannerTop.vue?vue&type=script&lang=js&"
export * from "./bannerTop.vue?vue&type=script&lang=js&"
import style0 from "./bannerTop.vue?vue&type=style&index=0&id=aa423138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa423138",
  null
  
)

export default component.exports